import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from "@angular/core";
import { GassClaims } from "src/app/auth/gass-claims";
import { IdentityService } from "src/app/auth/identity.service";
import { CisAllegato } from "src/app/shared/models/cisAllegato.model";

@Component({
  selector: "app-cis-allegati",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./cis-allegati.component.html",
  styleUrls: ["./cis-allegati.component.scss"],
})
export class CISAllegatiComponent {
  private readonly identityService = inject(IdentityService);

  cis = input<CisAllegato[] | null>(null);
  isLocked = input<boolean>(false);
  isArrivo = input<boolean>(false);
  showHeader = input<boolean>(true);
  isDocDestroyed = input<boolean>(false);

  addCIS = output();
  modifyCIS = output<CisAllegato>();
  distruggiCIS = output<CisAllegato>();
  recuperaCIS = output<CisAllegato>();
  restituisciCIS = output<CisAllegato>();

  public GassClaims = GassClaims;

  public onDistruggiCIS(e: MouseEvent, cisAllegato: CisAllegato): void {
    e.stopPropagation();
    this.distruggiCIS.emit(cisAllegato);
  }

  public onRecuperaCIS(e: MouseEvent, cisAllegato: CisAllegato): void {
    e.stopPropagation();
    this.recuperaCIS.emit(cisAllegato);
  }

  public onRestituisciCIS(e: MouseEvent, cisAllegato: CisAllegato): void {
    e.stopPropagation();
    this.restituisciCIS.emit(cisAllegato);
  }

  public onModificaCIS(e: MouseEvent, cisAllegato: CisAllegato): void {
    e.stopPropagation();
    this.modifyCIS.emit(cisAllegato);
  }

  public isAllegatoCISRestituitoDistrutto(cisAllegato: CisAllegato): boolean {
    return (
      cisAllegato.restituzioneData != null ||
      cisAllegato.distruzioneData != null
    );
  }

  public isDisabled(cisAllegato: CisAllegato): boolean {
    return (
      this.isAllegatoCISRestituitoDistrutto(cisAllegato) ||
      this.isLocked() ||
      !this.isArrivo()
    );
  }

  public showUndoDeleteAllegatoCIS(cisAllegato: CisAllegato): boolean {
    return (
      cisAllegato.distruzioneData != null &&
      (!this.isDocDestroyed() || !this.isLocked())
    );
  }

  public isModifiedDisabled(cisAllegato: CisAllegato): boolean {
    return (
      !this.identityService.hasClaim(GassClaims.CisModifica) ||
      this.isAllegatoCISRestituitoDistrutto(cisAllegato) ||
      this.isLocked()
    );
  }

  public getCISIconClass(tipoCIS: string): string {
    switch (tipoCIS) {
      case "CD":
      case "DVD":
        return "fas fa-compact-disc";
      case "Hard Disk":
      case "HD":
        return "fas fa-hdd";
      case "Smart Card":
        return "fa-regular fa-credit-card";
      case "Pennetta USB":
      case "USB":
        return "fa fa-sd-card";
      default:
        return "fas fa-compact-disc";
    }
  }

  public getClassificaSigla(classificaQualifica: string): string {
    const classifica = classificaQualifica.split(" ")[0];
    switch (classifica) {
      case "Riservato":
        return "R";
      case "Riservatissimo":
        return "RR";
      case "Segreto":
        return "S";
      case "Segretissimo":
        return "SS";
      // case 'Non Classificato':
      //   return 'NC';
      default:
        return "NC";
    }
  }

  public getItemClass(cisAllegato: CisAllegato): string {
    if (cisAllegato.distruzioneData) {
      return "destroyed-color";
    }

    if (cisAllegato.restituzioneData) {
      return "returned-color";
    }

    return "default-color";
  }
}
